module.exports = __webpack_public_path__ + "assets/img/08-m.7788e1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/08-m.jpg
// module id = jGeF
// module chunks = 0